module.exports = __webpack_public_path__ + "img/banner.d4dfd552.jpg";